import TableModulockerSet from "./TableModulockerSet";
export default TableModulockerSet;
export { default as TableModulockerSet } from './TableModulockerSet';